// imports
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(ScrollTrigger);

// cookie functions
function createCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toGMTString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
}

//////////////////////////////////////////////////

// https://codepen.io/aaroniker/pen/MWWRJzM

function inViewport(elem, callback, options = {}) {
	return new IntersectionObserver((entries) => {
		entries.forEach((entry) => callback(entry));
	}, options).observe(elem);
}

// change `no-js` to `js` in header (taken from Modernizr)
(function () {
	var className = document.documentElement.className;
	var reJS = new RegExp("(^|\\s)no-js(\\s|$)");
	document.documentElement.className = className.replace(reJS, "$1js$2");

	//////////////////////////////////////////////////
	// Fix for IE 10 issues
	document.documentElement.setAttribute("data-useragent", navigator.userAgent);
})();

(function() {
	if(document.querySelector(".cursor-circle")) {
		document.querySelector(".cursor-circle").classList.add("active");
		gsap.set(".cursor-circle", {xPercent: -50, yPercent: -50});

		let xTo = gsap.quickTo(".cursor-circle", "x", {duration: 0.1, ease: "power3"}),
			yTo = gsap.quickTo(".cursor-circle", "y", {duration: 0.1, ease: "power3"});

		window.addEventListener("mousemove", e => {
			xTo(e.clientX);
			yTo(e.clientY);
		});

		document.addEventListener("mouseover", function(e) {
			const clickable = e.target.closest("a, button, [role='button'], input, select, textarea, .hs-form-checkbox, .clickable");
			if (clickable) {
				document.querySelector(".cursor-circle").classList.add("hover");
			}
		});
		document.addEventListener("mouseout", function(e) {
			const clickable = e.target.closest("a, button, [role='button'], input, select, textarea, .hs-form-checkbox, .clickable");
			if (clickable) {
				document.querySelector(".cursor-circle").classList.remove("hover");
			}
		});
	}
})();


// show video
(function () {
	$(document).on("touchstart click", ".video-play", function (event) {
		event.preventDefault();
		$(this).parent().find("iframe").addClass("active");
	});
})();

// smooth scroll to anchor links
(function () {
	$(document).on("click", 'a[href^="#"]', function (event) {
		event.preventDefault();
		var href = $(this).attr("href");
		var elem = $(href);
		var top = elem && elem.length > 0 ? elem.offset().top : 0;
		// Account for fixed header height
		top -= $("header").outerHeight();
		$("html, body").animate(
			{
				scrollTop: top,
			},
			500,
		);
	});
})();

// use light header?
(function () {
	if (
		$(".main > .image-hero:first-child").length > 0 ||
		$(".main > .hero-dark:first-child").length > 0 ||
		$(".main > .contact-hero:first-child").length > 0 ||
		$(".main > .casestudy-hero:first-child").length > 0 ||
		$(".main > .hero-stacked:first-child").length > 0 ||
		$(".main > .use-light-header:first-child").length > 0
	) {
		$("body").addClass("light-header");
	}
})();

// scrolled header
(function () {
	function checkScrollPosition() {
		var scrollPos = $(window).scrollTop();
		if (scrollPos >= 50) {
			$("header").addClass("scrolled");
		} else {
			$("header").removeClass("scrolled");
		}
	}
	
	// Check on page load
	$(document).ready(function() {
		checkScrollPosition();
	});
	
	// Check on scroll
	$(window).scroll(checkScrollPosition);
})();

// toggle menu
(function () {
	$(document).on("click", ".header button.nav-toggle", function (event) {
		event.preventDefault();
		const nav = $("header .header nav");

		if ($("body").hasClass("show-menu")) {
			$("body").removeClass("show-menu");

			if (nav.hasClass("active-sub-subnav") || nav.hasClass("active-subnav")) {
				let activesubSubnav = $(".header--sub-subnav.active");
				let activeSubnav = $(".header--subnav.active");
				if (activesubSubnav) {
					activesubSubnav.css("display", "none");
					activesubSubnav.removeClass("active");
				}
				if (activeSubnav) {
					activeSubnav.css("display", "none");
					activeSubnav.removeClass("active");
				}
				nav.removeClass("active-sub-subnav");
				nav.removeClass("active-subnav");
			}

			if (nav) {
				setTimeout(() => {
					nav.css("display", "none");
				}, 250);
			}
		} else {
			if (nav) {
				nav.css("display", "block");
			}
			setTimeout(() => {
				$("body").addClass("show-menu");
			}, 25);
		}
	});

	$(window).on("resize", function (event) {
		const nav = $("header .header nav");
		if ($("body").hasClass("show-menu")) {
			$("body").removeClass("show-menu");
			nav.css("display", "none");

			if (nav.hasClass("active-sub-subnav") || nav.hasClass("active-subnav")) {
				let activesubSubnav = $(".header--sub-subnav.active");
				let activeSubnav = $(".header--subnav.active");
				if (activesubSubnav) {
					activesubSubnav.css("display", "none");
					activesubSubnav.removeClass("active");
				}
				if (activeSubnav) {
					activeSubnav.css("display", "none");
					activeSubnav.removeClass("active");
				}
				nav.removeClass("active-sub-subnav");
				nav.removeClass("active-subnav");
			}
		}
	});
})();

// Alpine.js mobile nav logo color fix for header--white
(function () {
	// Watch for mobile nav state changes and update logo accordingly
	function updateLogoForMobileNav() {
		const mobileNav = document.querySelector('.header--mobile-nav');
		const logo = document.querySelector('.header--logo img');
		const header = document.querySelector('header');
		
		if (!mobileNav || !logo || !header) return;
		
		// Check if header has white class
		const isWhiteHeader = header.classList.contains('header--white');
		
		// More robust check for mobile nav visibility (Alpine.js uses inline styles)
		const computedStyle = window.getComputedStyle(mobileNav);
		const isMobileNavVisible = computedStyle.display !== 'none';
		
		if (isWhiteHeader) {
			if (isMobileNavVisible) {
				// When mobile nav is open on white header, show original logo colors (remove invert)
				logo.style.setProperty('filter', 'unset', 'important');
			} else {
				// When mobile nav is closed on white header, let CSS handle the white filter
				logo.style.removeProperty('filter');
			}
		} else {
			// Reset to default for non-white headers
			logo.style.removeProperty('filter');
		}
	}
	
	// Initial check
	setTimeout(updateLogoForMobileNav, 100);
	
	// Use MutationObserver to watch for style changes on mobile nav
	if (typeof MutationObserver !== 'undefined') {
		const mobileNav = document.querySelector('.header--mobile-nav');
		
		if (mobileNav) {
			const observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
						// Check if mobile nav is visible and manage body scroll
						const computedStyle = window.getComputedStyle(mobileNav);
						const isMobileNavVisible = computedStyle.display !== 'none';
						
						if (isMobileNavVisible) {
							// Simply prevent body scrolling when mobile nav is open
							document.body.classList.add('mobile-nav-open');
						} else {
							// Allow body scrolling when mobile nav is closed
							document.body.classList.remove('mobile-nav-open');
						}
						
						setTimeout(updateLogoForMobileNav, 10);
					}
				});
			});
			
			observer.observe(mobileNav, {
				attributes: true,
				attributeFilter: ['style']
			});
		}
	}
	
	// Also listen for clicks on mobile nav buttons as backup
	document.addEventListener('click', function(e) {
		if (e.target.closest('.header--mobile-nav-button') || 
			e.target.closest('.header--mobile-nav-close')) {
			setTimeout(updateLogoForMobileNav, 50);
		}
	});
})();

// NEW toggle mobile menus
(function () {
	if ($(".header--open-subnav")) {
		const nav = $("header .header nav");
		let subnavButtons = $(".header--open-subnav");
		let subsubnavButtons = $(".header--open-sub-subnav");
		let closeSubNavButtons = $(".header--close-subnav");
		let closeSubsubnavButtons = $(".header--close-sub-subnav");

		subnavButtons.each(function () {
			$(this).on("click", function () {
				if (window.innerWidth < 1024) {
					let subnav = $(this).siblings(".header--subnav");
					if (subnav) {
						nav.addClass("active-subnav");
						subnav.css("display", "flex");
						setTimeout(() => {
							subnav.addClass("active");
						}, 25);
					}
				}
			});
		});

		closeSubNavButtons.each(function () {
			$(this).on("click", function () {
				if (window.innerWidth < 1024) {
					let subnav = $(this).siblings(".header--subnav");
					let activeSubnav = $(".header--subnav.active");
					if (activeSubnav) {
						nav.removeClass("active-subnav");
						activeSubnav.removeClass("active");
						setTimeout(() => {
							subnav.css("display", "none");
						}, 100);
					}
				}
			});
		});

		subsubnavButtons.each(function () {
			$(this).on("click", function () {
				if (window.innerWidth < 1024) {
					let subnav = $(this).siblings(".header--sub-subnav");
					if (subnav) {
						nav.addClass("active-sub-subnav");
						subnav.css("display", "flex");
						setTimeout(() => {
							subnav.addClass("active");
						}, 25);
					}
				}
			});
		});

		closeSubsubnavButtons.each(function () {
			$(this).on("click", function () {
				if (window.innerWidth < 1024) {
					let subnav = $(this).siblings(".header--sub-subnav");
					let activeSubnav = $(".header--sub-subnav.active");
					if (activeSubnav) {
						nav.removeClass("active-sub-subnav");
						activeSubnav.removeClass("active");
						setTimeout(() => {
							subnav.css("display", "none");
						}, 100);
					}
				}
			});
		});
	}
})();

// notification bar
(function () {
	if ($(".notice-bar").length > 0) {
		$("body").addClass("has-notification-bar");
		$(document).on("click", "#close-notice-bar", function (event) {
			event.preventDefault();
			$("body").removeClass("has-notification-bar");
			$(this).closest(".notice-bar").remove();
		});
	}
})();

// search form
(function () {
	$(document).on("click", ".fa-search", function (event) {
		event.preventDefault();
		$(".global-search").toggleClass("active");
	});
	$(document).on("click", "#search-close", function (event) {
		event.preventDefault();
		$(".global-search").toggleClass("active");
	});
})();

// team members grid (accessible)
function displayTeamMembers(attribute, scroll) {
	$(".grid-categories--cards .card-employee").css("display", "inline-block");
	$(".grid-categories--cards .card-employee:not(." + attribute + ")").css(
		"display",
		"none",
	);
	if (scroll) {
		$("html, body").animate(
			{
				scrollTop: $(".grid-categories--cards").offset().top - 250,
			},
			500,
		);
	}
}
(function () {
	const $buttons = $(".grid-categories--categories ul li button");
	const $firstButton = $buttons.first();
	$firstButton.addClass("active").attr("aria-pressed", "true").attr("tabindex", "0");
	$buttons.not($firstButton).attr("aria-pressed", "false").attr("tabindex", "-1");
	var attri = $firstButton.attr("data-slug");
	displayTeamMembers(attri, false);

	$buttons.on("click", function (event) {
		event.preventDefault();
		$buttons.removeClass("active").attr("aria-pressed", "false").attr("tabindex", "-1");
		$(this).addClass("active").attr("aria-pressed", "true").attr("tabindex", "0");
		displayTeamMembers($(this).attr("data-slug"), true);
		$(this).focus();
	});

	// Keyboard navigation (arrow keys)
	$buttons.on("keydown", function (event) {
		let idx = $buttons.index(this);
		if (event.key === "ArrowRight" || event.keyCode === 39) {
			event.preventDefault();
			let next = (idx + 1) % $buttons.length;
			$buttons.eq(next).click();
		} else if (event.key === "ArrowLeft" || event.keyCode === 37) {
			event.preventDefault();
			let prev = (idx - 1 + $buttons.length) % $buttons.length;
			$buttons.eq(prev).click();
		}
	});
})();

// "logo slider" carousel
(function () {
	if(document.querySelector(".logo-slider .splide")) {
		new Splide(".logo-slider .splide", {
			arrows: false,
			pagination: false,
			drag: false,
			perMove: 1,
			autoWidth: true,
			gap: "2.75rem",
			height: "6.25rem",
			mediaQuery: 'min',
			type: 'loop',
			autoScroll: {
				speed: .5,
				pauseOnHover: false,
				pauseOnFocus: false
			},
			breakpoints: {
				1023: {
					gap: "3.5rem",
				},
			},
		}).mount({AutoScroll});
	}
})();

// content-with-carousel--carousel
(function () {
	if(document.querySelector(".content-with-carousel")) {
		// If there are multiple instances of the slider, loop through each one
		document.querySelectorAll(".content-with-carousel").forEach((block) => {
			let slider = block.querySelector(".splide");
			let nextButton = slider.querySelector(".splide__arrow--next");
			let contentWrapper = block.querySelector(".content-with-carousel--text-wrapper");
			let contentItems = block.querySelectorAll(".content-with-carousel--text");
			let sliderTimeout = null;

			const splider = new Splide(slider, {
				type: "loop",
				arrows: true,
				pagination: true,
				drag: true,
				slidesToScroll: 1,
				perPage: 1,
				perMove: 1,
				gap: "2.75rem",
				autoplay: true,
				resetProgress: true,
				interval: 10000,
			});

			const progressArrow = (Splide) => {
				function pauseArrow() {
					let nextButton = slider.querySelector(".splide__arrow--next");
					nextButton.classList.add("pause");
				}

				function resetArrow() {
					let nextButton = slider.querySelector(".splide__arrow--next");
					nextButton.classList.remove("pause");
					nextButton.classList.remove("anim");
					void nextButton.offsetWidth;
					nextButton.classList.add("anim");
				}

				return {
					mount() {
						Splide.on("autoplay:pause", () => {
							pauseArrow();
						});
						Splide.on("autoplay:play", () => {
							resetArrow();
						});
						Splide.on("mounted", () => {
							resetArrow();
						});
					}
				}
			}

			splider.on("move", function (newIndex) {
				if (sliderTimeout) {
					clearTimeout(sliderTimeout);
				} else {
					contentWrapper.classList.add("fade-out");
				}

				sliderTimeout = setTimeout(() => {
					// Update the content items based on the current slide
					contentItems.forEach((item, index) => {
						if (index === newIndex) {
							item.classList.add("is-active");
						} else {
							item.classList.remove("is-active");
						}
					});
					contentWrapper.classList.remove("fade-out");
					sliderTimeout = null;
				}, 300);
			});

			splider.mount({progressArrow})
		});
	}
})();

// "content ratings and logos" carousel
(function () {
	if(document.querySelectorAll(".content-ratings-and-logos--slider.splide").length > 0) {
		// If there are multiple instances of the slider, loop through each one
		document.querySelectorAll(".content-ratings-and-logos--slider.splide").forEach((slider) => {
			// Initialize the Splide slider
			new Splide(slider, {
				arrows: false,
				pagination: false,
				drag: false,
				perMove: 1,
				autoWidth: true,
				gap: "2.75rem",
				height: "6.25rem",
				padding: "4rem",
				mediaQuery: 'min',
				type: 'loop',
				autoScroll: {
					speed: .5,
					pauseOnHover: false,
					pauseOnFocus: false
				},
				breakpoints: {
					1023: {
						gap: "3.5rem",
					},
				},
			}).mount({AutoScroll});
		});
	}
})();

// content tabs
(function () {
	if(document.querySelector(".content-tabs .splide")) {
		let blocks = document.querySelectorAll('.content-tabs');

		for (let i = 0; i < blocks.length; i++) {
			let block = blocks[i];
			let slider = block.querySelector('.splide');
			let slideElements = block.querySelectorAll('.tab-content.splide__slide');
			let tabArray = [];
			let pagination = slider.querySelector('.inner-pagination');
			let initialized = false;

			slideElements.forEach((slideElement, j) => {
				tabArray[j] = slideElement.dataset.tab;
			});

			inViewport(
				slider,
				(element) => {
				if (!element.isIntersecting || initialized) return;
					let splide = new Splide(slider, {
						type: "fade",
						perPage: 1,
						perMove: 1,
						rewind: false,
						arrows: false,
						pagination: true,
						padding: "1.25rem",
						gap: "2rem",
						mediaQuery: "min",
						breakpoints: {
							1023: {
								padding: 0
							},
						}
					})

					splide.on("move", function (newIndex) {
						let paginationItems = pagination.querySelectorAll(
							'[role="presentation"]',
						);

						if (paginationItems[newIndex]) {
							const paginationItemLeft = paginationItems[newIndex].offsetLeft;
							const paginationItemWidth = paginationItems[newIndex].offsetWidth;
							const paginationItemCenter =
								paginationItemLeft + paginationItemWidth;
							const paginationElementWidth = pagination.offsetWidth;

							if (paginationItemCenter > paginationElementWidth) {
								const paginationElementWidth = pagination.offsetWidth;
								const transformX =
									paginationItemCenter -
									paginationElementWidth +
									paginationItemWidth / 2;
								pagination.style.transform = `translateX(calc(-${transformX}px + (.44rem * (${paginationItems.length} - 1))))`;
							} else {
								pagination.style.transform = `translateX(0)`;
							}
						}
					});

					splide.on("pagination:mounted", function (data) {
						data.items.forEach(function (item, o) {
							if (tabArray[o]) {
								item.button.innerHTML = tabArray[o];
							}
						});
					});

					splide.mount();

					initialized = true;
				}
			);
		}
	}
})();


// content tabs
(function () {
	if(document.querySelector(".content-tabs-slider .splide")) {
		let blocks = document.querySelectorAll('.content-tabs-slider');

		for (let i = 0; i < blocks.length; i++) {
			let block = blocks[i];
			let slider = block.querySelector('.splide');
			let nextButton = slider.querySelector(".splide__arrow--next");
			let slideElements = block.querySelectorAll('.tab-content.splide__slide');
			let tabArray = [];
			let pagination = slider.querySelector('.inner-pagination');
			let initialized = false;
			let images = block.querySelectorAll('.img-wrapper');

			slideElements.forEach((slideElement, j) => {
				tabArray[j] = slideElement.dataset.tab;
			});

			inViewport(
				slider,
				(element) => {
				if (!element.isIntersecting || initialized) return;
					let splide = new Splide(slider, {
						type: "fade",
						perPage: 1,
						perMove: 1,
						rewind: true,
						arrows: true,
						pagination: true,
						padding: "1.25rem",
						gap: "2rem",
						mediaQuery: "min",
						autoplay: true,
						resetProgress: true,
						interval: 10000,
						breakpoints: {
							1023: {
								padding: 0
							},
						}
					})

					const progressArrow = (Splide) => {
						function pauseArrow() {
							let nextButton = slider.querySelector(".splide__arrow--next");
							nextButton.classList.add("pause");
						}

						function resetArrow() {
							let nextButton = slider.querySelector(".splide__arrow--next");
							nextButton.classList.remove("pause");
							nextButton.classList.remove("anim");
							void nextButton.offsetWidth;
							nextButton.classList.add("anim");
						}

						return {
							mount() {
								Splide.on("autoplay:pause", () => {
									pauseArrow();
								});
								Splide.on("autoplay:play", () => {
									resetArrow();
								});
								Splide.on("mounted", () => {
									resetArrow();
								});
							}
						}
					}

					splide.on("move", function (newIndex) {
						// Update the images based on the current slide
						images.forEach((image, idx) => {
							image.classList.remove("active", "second", "third", "fourth");
							const total = images.length;
							if (idx === newIndex % total) {
								image.classList.add("active");
							} else if (idx === (newIndex + 1) % total) {
								image.classList.add("second");
							} else if (idx === (newIndex + 2) % total) {
								image.classList.add("third");
							} else if (idx === (newIndex + 3) % total) {
								image.classList.add("fourth");
							}
						});
					});

					splide.on("pagination:mounted", function (data) {
						data.items.forEach(function (item, o) {
							if (tabArray[o]) {
								item.button.innerHTML = tabArray[o];
							}
						});
					});

					splide.mount({progressArrow});

					// Add swipe functionality to images (mobile only)
					const imagesWrapper = block.querySelector('.images-wrapper');
					if (imagesWrapper) {
						let startX = null;
						let startY = null;
						let endX = null;
						let endY = null;

						// Touch events (mobile only)
						imagesWrapper.addEventListener('touchstart', function(e) {
							startX = e.touches[0].clientX;
							startY = e.touches[0].clientY;
						}, { passive: true });

						imagesWrapper.addEventListener('touchmove', function(e) {
							endX = e.touches[0].clientX;
							endY = e.touches[0].clientY;
						}, { passive: true });

						imagesWrapper.addEventListener('touchend', function(e) {
							if (startX === null || endX === null) {
								return;
							}

							const deltaX = endX - startX;
							const deltaY = endY - startY;
							const minSwipeDistance = 50;

							// Check if it's a horizontal swipe (more horizontal than vertical)
							if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
								if (deltaX > 0) {
									// Swipe right - go to previous slide
									splide.go('<');
								} else {
									// Swipe left - go to next slide
									splide.go('>');
								}
							}

							// Reset values
							startX = null;
							startY = null;
							endX = null;
							endY = null;
						}, { passive: true });
					}

					initialized = true;
				}
			);
		}
	}
})();

// "Content - Image Slider" carousel
(function () {
	$(".img-slider .img-slider--slides").slick({
		arrows: true,
		centerMode: true,
		dots: true,
		infinite: true,
		mobileFirst: true,
		slidesToShow: 1,
	});
})();

// "testimonials" tabs
(function () {
	let testimonialSelectors = document.querySelectorAll(".testimonial-selector");

	testimonialSelectors.forEach((element) => {
		let testimonialPath = element.querySelector(".testimonial-selector--slider-shape svg path")
		let testimonials = element.querySelectorAll(".card-testimonial")
		let nextButton = element.querySelector(".testimonial-selector--button.next")
		let prevButton = element.querySelector(".testimonial-selector--button.prev")
		let testimonialPositions = []
		let slideTimeout = null
		let indexArray = { '-0.5': 1, '-0.25': 2, '0': 3, '0.25': 4, '0.5': 5, '0.75': 4, '1': 3, '1.25': 2, '1.5': 1, '1.75': 0 };

		function startSlideTimer() {
			resetArrow()
		}

		function updateZ() {
			testimonials.forEach((testimonial, i) => {
				let zIndex = indexArray[testimonialPositions[i]]
				if(zIndex !== undefined) {
					testimonial.style.zIndex = zIndex
				} else {
					testimonial.style.zIndex = -1
				}
			})
		}

		function resetArrow() {
			let nextButton = element.querySelector(".testimonial-selector--button.next")
			nextButton.classList.remove("pause");
			nextButton.classList.remove("anim");
			void nextButton.offsetWidth;
			nextButton.classList.add("anim");
			clearInterval(slideTimeout)
			slideTimeout = null
			// Restart the timer after a short delay to allow for the animation to reset
			setTimeout(() => {
				nextButton.classList.add("anim");
				slideTimeout = setInterval(() => {
					positionsForward()
				}, 10000)
			}, 50)
		}

		function retainPositions() {
			testimonials.forEach((testimonial, i) => {
				let position = testimonialPositions[i]

				if(position > 1) {
					gsap.set(testimonial, {
						motionPath: {
							path: testimonialPath,
							align: testimonialPath,
							alignOrigin: [0.5, 0.5],
							end: 1
						},
						transformOrigin: "50% 50%"
					})
				} else if(position < 0) {
					gsap.set(testimonial, {
						motionPath: {
							path: testimonialPath,
							align: testimonialPath,
							alignOrigin: [0.5, 0.5],
							end: 0
						},
						transformOrigin: "50% 50%"
					})
				} else {
					gsap.set(testimonial, {
						motionPath: {
							path: testimonialPath,
							align: testimonialPath,
							alignOrigin: [0.5, 0.5],
							end: position
						},
						transformOrigin: "50% 50%"
					})
				}
			})
		}
		
		function updatePositions(dir) {
			testimonials.forEach((testimonial, i) => {
				if(dir === "forward") {
					if(testimonialPositions[i] < -0.5) {
						testimonialPositions[i] = testimonialPositions[i] + (.25 * testimonials.length)
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 1
							}
						})
					} else if(testimonialPositions[i] < 0) {
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 0
							}
						})
					} else if(testimonialPositions[i] >= 1) {
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 1
							}
						})
					} else {
						let startPos = testimonialPositions[i] + 0.25
						let autoRotateOffset = 180
						if (startPos > 1) startPos = 1
						gsap.to(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: autoRotateOffset,
								start: startPos,
								end: testimonialPositions[i]
							}
						})
					}
				} else {
					if(testimonialPositions[i] > 1.5) {
						testimonialPositions[i] = testimonialPositions[i] - (.25 * testimonials.length)
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 0
							}
						})
					} else if(testimonialPositions[i] <= 0) {
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 0
							}
						})
					} else if(testimonialPositions[i] > 1) {
						gsap.set(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: true,
								end: 1
							}
						})
					} else {
						let startPos = testimonialPositions[i] - 0.25
						let autoRotateOffset = 0
						if (startPos < 0) startPos = 0
						gsap.to(testimonial, {
							motionPath: {
								path: testimonialPath,
								align: testimonialPath,
								alignOrigin: [0.5, 0.5],
								autoRotate: autoRotateOffset,
								start: startPos,
								end: testimonialPositions[i]
							}
						})
					}
				}

				if(testimonialPositions[i] < -.5 || testimonialPositions[i] > 1.25) {
					testimonial.classList.add("hidden")
				} else {
					testimonial.classList.remove("hidden")
				}
			})
		}

		function positionsForward() {
			let newPositions = []

			testimonialPositions.forEach((position, i) => {
				let newPosition = position - 0.25
				newPositions[i] = newPosition
			})

			testimonialPositions = newPositions
			updateZ()
			
			updatePositions("forward")
			resetArrow()
		}

		function positionsBackwards() {
			let newPositions = []

			testimonialPositions.forEach((position, i) => {
				let newPosition = position + 0.25
				newPositions[i] = newPosition
			})

			testimonialPositions = newPositions
			updateZ()
			
			updatePositions("backwards")
			resetArrow()
		}

		// initial positions
		testimonials.forEach((testimonial, i) => {
			let position = -.5 + (i * 0.25)
			if(position > 1) {
				gsap.set(testimonial, {
					motionPath: {
						path: testimonialPath,
						align: testimonialPath,
						alignOrigin: [0.5, 0.5],
						autoRotate: true,
						end: 1
					},
					transformOrigin: "50% 50%"
				})
			} else if(position < 0) {
				gsap.set(testimonial, {
					motionPath: {
						path: testimonialPath,
						align: testimonialPath,
						alignOrigin: [0.5, 0.5],
						autoRotate: true,
						end: 0
					},
					transformOrigin: "50% 50%"
				})
			} else {
				gsap.set(testimonial, {
					motionPath: {
						path: testimonialPath,
						align: testimonialPath,
						alignOrigin: [0.5, 0.5],
						autoRotate: true,
						end: position
					},
					transformOrigin: "50% 50%"
				})
			}
			testimonialPositions[i] = position
		})

		updateZ()

		window.addEventListener("resize", () => {
			retainPositions()
		})

		nextButton.addEventListener("click", () => {
			positionsForward()
		})

		prevButton.addEventListener("click", () => {
			positionsBackwards()
		})

		startSlideTimer()

		// testimonials.forEach((testimonial, i) => {
		// 	testimonial.addEventListener("click", () => {
		// 		let clickedPosition = testimonialPositions[i]
		// 		let newPositions = []
		// 		let killTimer = true

		// 		if(clickedPosition !== .5) {
		// 			testimonials.forEach((testimonial, j) => {
		// 				if (j !== i) {
		// 					let diff = i - j
		// 					let newPosition = .5 + (diff * 0.25)
		// 					if (newPosition < 0) {
		// 						newPosition = 0
		// 					}
		// 					if (newPosition > 1) {
		// 						newPosition = 1
		// 					}
		// 					if(newPosition == .75) {
		// 						killTimer = false
		// 					}
		// 					newPositions[j] = newPosition
		// 				} else {
		// 					newPositions[j] = .5
		// 				}
		// 			})
					
		// 			testimonials.forEach((testimonial, o) => {
		// 				gsap.from(testimonial, {
		// 					motionPath: {
		// 						path: testimonialPath,
		// 						align: testimonialPath,
		// 						alignOrigin: [0.5, 0.5],
		// 						autoRotate: true,
		// 						start: testimonialPositions[o],
		// 						end: newPositions[o]
		// 					}
		// 				})
		// 			})

		// 			testimonialPositions = newPositions

		// 			if (killTimer) {
		// 				// If we are at the end of the testimonials, pause the next button
		// 				pauseArrow()
		// 				clearInterval(slideTimeout)
		// 				slideTimeout = null
		// 			} else if(slideTimeout === null) {
		// 				// If we are not at the end of the testimonials, start the timer again
		// 				startSlideTimer()
		// 			}
		// 		}
		// 	})
		// })
	})
})();

// callout-partner-network functions
(function () {
	let blocks = document.querySelectorAll(".callout-partner-network");

	blocks.forEach((block) => {
		let networkContainer = block.querySelector(".callout-partner-network--network-container");
		let networkCenter = block.querySelector(".network-center");
		let networkLogos = block.querySelectorAll(".network-logo");

		const numLogos = networkLogos.length;
		const radiusPercent = 180;

		let animTl = gsap.timeline({
			scrollTrigger: {
				trigger: networkContainer,
				start: "25% center",
				end: "25% center",
				scrub: false,
				markers: false,
				invalidateOnRefresh: true,
				onEnter: () => {
					animTl.to(networkCenter, {
						scale: 1,
						duration: .25 + 0.2 * (numLogos),
						ease: "power1.inOut",
					});

					networkLogos.forEach((logo, i) => {
						const angleOffset = 0.45; // adjust this value as needed
						const angle = (2 * Math.PI * i) / numLogos - Math.PI / 2 + angleOffset;
						const xPercent = Math.cos(angle) * radiusPercent;
						const yPercent = Math.sin(angle) * radiusPercent;

						animTl.to(logo, {
							transform: `translate(-50%, -50%) translate(${xPercent}%, ${yPercent}%)`,
							duration: 0.25,
							ease: "power1.inOut",
							delay: 0.1,
						}, "<");
					});
				}
			}
		});
	});
})();

// related-content
(function () {
	let relatedContentSelectors = document.querySelectorAll(".related-content");
	relatedContentSelectors.forEach((element) => {
		let slider = element.querySelector(".splide")
		let nextButton = slider.querySelector(".splide__arrow--next");

		let splider = new Splide(slider, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			rewind: false,
			arrows: true,
			pagination: false,
			padding: "1.25rem",
			gap: "2.5rem",
			mediaQuery: "min",
			centerMode: true,
			autoplay: true,
			resetProgress: true,
			interval: 10000,
			breakpoints: {
				1023: {
					destroy: true
				}
			}
		});

		const progressArrow = (Splide) => {
			function pauseArrow() {
				let nextButton = slider.querySelector(".splide__arrow--next");
				nextButton.classList.add("pause");
			}

			function resetArrow() {
				let nextButton = slider.querySelector(".splide__arrow--next");
				nextButton.classList.remove("pause");
				nextButton.classList.remove("anim");
				void nextButton.offsetWidth;
				nextButton.classList.add("anim");
			}

			return {
				mount() {
					Splide.on("autoplay:pause", () => {
						pauseArrow();
					});
					Splide.on("autoplay:play", () => {
						resetArrow();
					});
					Splide.on("mounted", () => {
						resetArrow();
					});
				}
			}
		}

		splider.mount({progressArrow})
	})
})();

// content-case-studies-grid
(function() {
    let contentCaseStudiesGridSelectors = document.querySelectorAll(".content-case-studies-grid");
    contentCaseStudiesGridSelectors.forEach((element)=>{
        let slider = element.querySelector(".splide");
        let nextButton = slider.querySelector(".splide__arrow--next");
        let splider = new Splide(slider, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			rewind: false,
			arrows: true,
			pagination: false,
			padding: "1.25rem",
			gap: "2.5rem",
			mediaQuery: "min",
			centerMode: true,
			autoplay: true,
			resetProgress: true,
			interval: 10000,
			breakpoints: {
				1023: {
					destroy: true
				}
			}
		});
        const progressArrow = (Splide)=>{
            function pauseArrow() {
                let nextButton = slider.querySelector(".splide__arrow--next");
                nextButton.classList.add("pause");
            }
            function resetArrow() {
                let nextButton = slider.querySelector(".splide__arrow--next");
                nextButton.classList.remove("pause");
                nextButton.classList.remove("anim");
                nextButton.offsetWidth;
                nextButton.classList.add("anim");
            }
            return {
                mount () {
                    Splide.on("autoplay:pause", ()=>{
                        pauseArrow();
                    });
                    Splide.on("autoplay:play", ()=>{
                        resetArrow();
                    });
                    Splide.on("mounted", ()=>{
                        resetArrow();
                    });
                }
            };
        };
        splider.mount({
            progressArrow
        });
    });
})();

// "gallery-with-quote" tabs
(function () {
	$(".gallery-with-quote--content-images ul").slick({
		adaptiveHeight: true,
		arrows: true,
		dots: true,
		infinite: true,
		mobileFirst: true,
		slidesToScroll: 1,
		slidesToShow: 1,
	});
})();

// wow animations
(function () {
	var wow = new window.WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
	});
	wow.init();
})();

// notification
(function () {
	// If the 'hide cookie is not set we show the message
	if (!readCookie("hide")) {
		$("#notification-popup").show();
	}

	// Add the event that closes the popup and sets the cookie that tells us to
	// not show it again until one day has passed.
	$("#close").click(function () {
		$("#notification-popup").hide();
		createCookie("hide", true, 1);
		return false;
	});
})();

// Function to update body padding based on notice bar height
function updateBodyPaddingForNoticeBar() {
	var $header = $("header");
	var $noticeBar = $(".notice-bar");
	
	// Only apply padding if header has overlap classes
	if (!$header.hasClass("header--overlap-white") && !$header.hasClass("header--overlap")) {
		return;
	}
	
	var currentPadding = parseInt($("body").css("padding-top")) || 0;
	var existingNoticeBarPadding = parseInt($("body").attr("data-notice-bar-padding")) || 0;
	
	// Remove existing notice bar padding
	var basePadding = currentPadding - existingNoticeBarPadding;
	
	if ($noticeBar.is(":visible") && $noticeBar.length > 0) {
		var noticeBarHeight = $noticeBar.outerHeight();
		var newPadding = basePadding + noticeBarHeight;
		
		$("body").css("padding-top", newPadding + "px");
		$("body").attr("data-notice-bar-padding", noticeBarHeight);
	} else {
		$("body").css("padding-top", basePadding + "px");
		$("body").attr("data-notice-bar-padding", "0");
	}
}

// If the 'hide cookie is not set we show the message
if (!readCookie("notif-bar-hide") && $(".notice-bar").length > 0) {
	$(".notice-bar").show();
	$("body").addClass("notice-bar--active");
	// Update padding after showing
	setTimeout(updateBodyPaddingForNoticeBar, 10);
	// Trigger custom event for marquee initialization
	$(document).trigger('noticeBarShown');
} else if ($(".notice-bar").length > 0) {
	$(".notice-bar").hide();
	$("body").removeClass("notice-bar--active");
	updateBodyPaddingForNoticeBar();
}

// Add the event that closes the popup and sets the cookie that tells us to
// not show it again until one day has passed.
$("#close-notice-bar").click(function () {
	$(".notice-bar").hide();
	$("body").removeClass("notice-bar--active");
	createCookie("notif-bar-hide", true, 1);
	// Update padding after hiding
	setTimeout(updateBodyPaddingForNoticeBar, 10);
	return false;
});

// GLOBAL PERFORMANCE MANAGER - Handles all scroll/resize events efficiently
(function() {
	var scrollHandlers = [];
	var resizeHandlers = [];
	var isScrolling = false;
	var isResizing = false;
	
	// Throttled scroll processor
	function processScroll() {
		if (!isScrolling) {
			requestAnimationFrame(function() {
				for (var i = 0; i < scrollHandlers.length; i++) {
					scrollHandlers[i]();
				}
				isScrolling = false;
			});
			isScrolling = true;
		}
	}
	
	// Debounced resize processor
	var resizeTimeout;
	function processResize() {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			for (var i = 0; i < resizeHandlers.length; i++) {
				resizeHandlers[i]();
			}
			// Refresh ScrollTrigger after all resize handlers complete
			if (window.ScrollTrigger) {
				window.ScrollTrigger.refresh();
			}
		}, 16);
	}
	
	// Public API for registering handlers
	window.PerformanceManager = {
		addScrollHandler: function(handler) {
			scrollHandlers.push(handler);
		},
		addResizeHandler: function(handler) {
			resizeHandlers.push(handler);
		},
		refreshScrollTrigger: function() {
			if (window.ScrollTrigger) {
				window.ScrollTrigger.refresh();
			}
		}
	};
	
	// Single global listeners
	window.addEventListener('scroll', processScroll, { passive: true });
	window.addEventListener('resize', processResize, { passive: true });
	
	// Register existing handlers
	window.PerformanceManager.addResizeHandler(updateBodyPaddingForNoticeBar);
})();

// Notice bar marquee animation - High Performance & Consistent Speed
(function () {
	var marqueeTimeline = null;
	var marqueeContainer = null;
	var marqueeTextElement = null;
	var $marqueeContent = null;
	var isAnimating = false;
	var resizeTimeout = null;
	
	// Performance constants
	var ANIMATION_SPEED = 60; // pixels per second (consistent speed)
	var PAUSE_DURATION = 2; // seconds
	var RESTART_PAUSE = 1.5; // seconds
	
	function initializeMarqueeElements() {
		$marqueeContent = $('.notice-bar__content');
		if ($marqueeContent.length > 0) {
			marqueeContainer = $marqueeContent[0];
			marqueeTextElement = $marqueeContent.children().first()[0];
			return marqueeContainer && marqueeTextElement;
		}
		return false;
	}
	
	function stopNoticeBarMarquee() {
		isAnimating = false;
		if (marqueeTimeline) {
			marqueeTimeline.kill();
			marqueeTimeline = null;
		}
		if (marqueeTextElement) {
			gsap.set(marqueeTextElement, { 
				clearProps: "x",
				force3D: false 
			});
		}
		if ($marqueeContent) {
			$marqueeContent.removeClass('marquee-active');
		}
	}
	
	function startNoticeBarMarquee() {
		// Stop any existing animation
		stopNoticeBarMarquee();
		
		// Initialize elements if not already done
		if (!initializeMarqueeElements()) {
			return;
		}
		
		// Get fresh measurements
		var containerWidth = marqueeContainer.offsetWidth;
		var textWidth = marqueeTextElement.offsetWidth;
		
		// Only animate if text is wider than container and notice bar is visible
		if (textWidth > containerWidth && $('.notice-bar').is(':visible')) {
			isAnimating = true;
			$marqueeContent.addClass('marquee-active');
			
			// Calculate distances and consistent durations
			var scrollInDistance = containerWidth; // Distance from right edge to left edge
			var scrollOutDistance = textWidth; // Distance to scroll completely off
			
			// Consistent speed calculations
			var scrollInDuration = scrollInDistance / ANIMATION_SPEED;
			var scrollOutDuration = scrollOutDistance / ANIMATION_SPEED;
			
			// Create infinite timeline with high performance settings
			marqueeTimeline = gsap.timeline({ 
				repeat: -1,
				onRepeat: function() {
					if (!isAnimating || !$('.notice-bar').is(':visible')) {
						stopNoticeBarMarquee();
					}
				}
			});
			
			// High performance GSAP settings
			gsap.set(marqueeTextElement, { 
				force3D: true,
				transformOrigin: "left center"
			});
			
			// Set initial position (off-screen right)
			marqueeTimeline.set(marqueeTextElement, { x: containerWidth });
			
			// Phase 1: Scroll in from right to left edge (consistent speed)
			marqueeTimeline.to(marqueeTextElement, {
				x: 0,
				duration: scrollInDuration,
				ease: "none"
			});
			
			// Phase 2: Pause at left edge for reading
			marqueeTimeline.to(marqueeTextElement, {
				x: 0,
				duration: PAUSE_DURATION,
				ease: "none"
			});
			
			// Phase 3: Continue scrolling off the left (same consistent speed)
			marqueeTimeline.to(marqueeTextElement, {
				x: -textWidth,
				duration: scrollOutDuration,
				ease: "none"
			});
			
			// Phase 4: Pause before restart
			marqueeTimeline.to(marqueeTextElement, {
				x: -textWidth,
				duration: RESTART_PAUSE,
				ease: "none"
			});
			
		} else {
			// Text fits or notice bar hidden - reset position
			if (marqueeTextElement) {
				gsap.set(marqueeTextElement, { 
					x: 0,
					force3D: false 
				});
			}
			if ($marqueeContent) {
				$marqueeContent.removeClass('marquee-active');
			}
		}
	}
	
	function handleResize() {
		if (resizeTimeout) {
			clearTimeout(resizeTimeout);
		}
		resizeTimeout = setTimeout(function() {
			if ($('.notice-bar').is(':visible')) {
				startNoticeBarMarquee();
			}
		}, 150);
	}
	
	// Initialize when notice bar is shown
	if (!readCookie("notif-bar-hide")) {
		setTimeout(startNoticeBarMarquee, 500);
	}
	
	// Handle window resize with debouncing
	$(window).on('resize', handleResize);
	
	// Stop animation when notice bar is closed
	$("#close-notice-bar").on("click", function() {
		stopNoticeBarMarquee();
	});
	
	// Reinitialize if notice bar is shown again
	$(document).on('noticeBarShown', function() {
		setTimeout(startNoticeBarMarquee, 100);
	});
	
	// Handle visibility change (tab switching, etc.)
	$(document).on('visibilitychange', function() {
		if (document.hidden) {
			stopNoticeBarMarquee();
		} else if (!readCookie("notif-bar-hide") && $('.notice-bar').is(':visible')) {
			setTimeout(startNoticeBarMarquee, 100);
		}
	});
})();

// sticky news filters
(function () {
	var bottomOffset = 147;
	var topOffset = 116;
	var minCards = 4;
	var $filters = $(".news-grid--filters");

	function updateFilterPositions() {
		if (window.innerWidth < 1024) {
			$filters.removeClass("is-fixed");
		} else {
			$filters.each(function () {
				var $filter = $(this);
				var filterBounds = $(this).get(0).getBoundingClientRect();
				var $parent = $filter.parents(".news-grid");
				var $cards = $parent.find(".card-news");
				var b = filterBounds.bottom + bottomOffset;
				if ($cards.length < minCards) {
					$filters.removeClass("is-fixed").removeClass("on-bottom");
				} else {
					var bounds = $parent.get(0).getBoundingClientRect();
					// if (bounds.bottom - window.innerHeight + $filter.height() - topOffset - bottomOffset <= 0) {

					if (
						bounds.bottom - $filter.height() - topOffset - bottomOffset <=
						0
					) {
						$filters.addClass("is-fixed").addClass("on-bottom");
					} else if (bounds.top + topOffset <= 0) {
						$filters.addClass("is-fixed").removeClass("on-bottom");
					} else {
						$filters.removeClass("is-fixed").removeClass("on-bottom");
					}
				}
			});
		}
	}

	if ($filters.length > 0) {
		$(window).resize(updateFilterPositions);
		$(window).scroll(updateFilterPositions);
	}
})();

// sticky grid categories
(function () {
	var bottomOffset = 20;
	var topOffset = 120;
	var $filters = $(".grid-categories--categories:eq(0)");

	function updateFilterPositions() {
		if (window.innerWidth < 1024) {
			$filters.removeClass("is-fixed");
		} else {
			$filters.each(function () {
				var $filter = $(this);
				var $parent = $filter.parents(".grid-categories");
				var bounds = $parent.get(0).getBoundingClientRect();
				if (
					bounds.bottom -
						window.innerHeight +
						$filter.height() -
						topOffset -
						bottomOffset <=
					0
				) {
					$filters.addClass("is-fixed").addClass("on-bottom");
				} else if (bounds.top + topOffset <= 0) {
					$filters.addClass("is-fixed").removeClass("on-bottom");
				} else {
					$filters.removeClass("is-fixed").removeClass("on-bottom");
				}
			});
		}
	}

	if ($filters.length > 0) {
		$(window).resize(updateFilterPositions);
		$(window).scroll(updateFilterPositions);
	}
})();

// fixed anchor subnav
(function () {
	var $header = $("header");
	var $subnav = $(".anchor-subnav:eq(0)");

	function updateSubnavPosition() {
		if (window.innerWidth < 1024) {
			$subnav.removeClass('is-fixed').css('transform', 'translateY(0)');
		} else {
			var $parent = $subnav.parent(".anchor-subnav--container");
			var bounds = $parent.get(0).getBoundingClientRect();
			var headerHeight = $header.outerHeight();
			var noticeBarHeight = $("body").hasClass("has-notification-bar") ? $(".notice-bar").outerHeight() : 0;
			var totalOffset = headerHeight + noticeBarHeight;

			if (bounds.top - totalOffset <= 0) {
				$subnav
					.addClass("is-fixed")
					.css("transform", "translateY(" + totalOffset + "px)");
			} else {
				$subnav.removeClass("is-fixed").css("transform", "translateY(0)");
			}
		}
	}

	if ($header.length > 0 && $subnav.length > 0) {
		$(window).resize(updateSubnavPosition);
		$(window).scroll(updateSubnavPosition);
	}
})();

// lazy load images
(function () {
	window.lazyLoader = new window.LazyLoad({ elements_selector: ".lazy" });
})();

// continue reading block
(function () {
	var allContinueReadingBlocks = document.body.querySelectorAll(
		"button[data-continue-reading-paragraph]",
	);
	for (var i = 0; i < allContinueReadingBlocks.length; i++) {
		var currentElement = allContinueReadingBlocks[i];
		// Set ARIA attributes for accessibility
		currentElement.setAttribute("aria-expanded", "false");
		currentElement.setAttribute("aria-controls", currentElement.dataset.continueReadingParagraph);

		currentElement.addEventListener("click", function (event) {
			var current = event.currentTarget;
			var targetParagraph = document.getElementById(
				current.dataset.continueReadingParagraph
			);
			var expanded = targetParagraph.classList.contains("continue-reading__paragraph--expanded");

			if (expanded) {
				targetParagraph.classList.remove("continue-reading__paragraph--expanded");
				targetParagraph.classList.add("continue-reading__paragraph--hidden");
				current.innerText = "Continue Reading";
				current.setAttribute("aria-expanded", "false");
				targetParagraph.setAttribute("aria-hidden", "true");
			} else {
				targetParagraph.classList.remove("continue-reading__paragraph--hidden");
				targetParagraph.classList.add("continue-reading__paragraph--expanded");
				current.innerText = "Hide Content";
				current.setAttribute("aria-expanded", "true");
				targetParagraph.setAttribute("aria-hidden", "false");
				// Set focus to the expanded paragraph
				targetParagraph.setAttribute("tabindex", "-1");
				targetParagraph.focus();
			}
		});

		// Allow keyboard activation (Enter/Space)
		currentElement.addEventListener("keydown", function (event) {
			if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
				event.preventDefault();
				this.click();
			}
		});
	}
})();

// hide and show fixed back to top button
// (function () {
// 	var backToTop = document.body.querySelector("#fixedBackToTop");
// 	window.addEventListener(
// 		"scroll",
// 		function (event) {
// 			if (window.scrollY < 300) {
// 				// Hide
// 				backToTop.classList.add("back-to-top--hidden");
// 			} else {
// 				// Show
// 				backToTop.classList.remove("back-to-top--hidden");
// 			}
// 		},
// 		{
// 			capture: true,
// 			passive: true,
// 		},
// 	);
// })();

// tabs
(function () {
	if ($("#tabs").length) {
		var tabsElement = document.querySelector("#tabs");
		var tabContentElements = tabsElement.querySelectorAll(".tab-content");
		var tabLinkElements = tabsElement.querySelectorAll("a.tab-link");
		if (!tabsElement) return;
		Array.from(tabLinkElements).forEach(function (element) {
			element.addEventListener("click", function (event) {
				event.preventDefault();
				var tabID = event.target.dataset.tab;
				Array.from(tabContentElements).forEach(function (contentElement) {
					if (contentElement.id === tabID) {
						contentElement.classList.remove("tab-content--hidden");
					} else {
						contentElement.classList.add("tab-content--hidden");
					}
				});
				Array.from(tabLinkElements).forEach(function (linkElement) {
					if (linkElement.dataset.tab === tabID) {
						linkElement.classList.add("tab-link--active");
					} else {
						linkElement.classList.remove("tab-link--active");
					}
				});
			});
		});
	}
})();

// integrations animation
(function () {
	if ($(".integrations-section").length) {
		TweenLite.to(".passport-logo--outer-ring img", 10, {
			rotation: "+=360",
			repeat: -1,
			ease: Linear.easeNone,
			transformOrigin: "50% 50%",
		});

		var windowHeight = $(window).innerHeight();

		let integrationsTimelineLeft = gsap.timeline({
			scrollTrigger: {
				trigger: $(".integrations-section--playground"),
				start: "225 " + windowHeight * (1 / 2),
				end: "225 " + windowHeight * (1 / 5),
				scrub: 0.75,
				markers: false,
			},
		});

		let integrationsTimelineRight = gsap.timeline({
			scrollTrigger: {
				trigger: $(".integrations-section--playground"),
				start: "250 " + windowHeight * (1 / 2),
				end: "250 " + windowHeight * (1 / 5),
				scrub: 0.75,
				markers: false,
			},
		});

		let integrationsTimelineLogo = gsap.timeline({
			scrollTrigger: {
				trigger: $(".integrations-section--playground"),
				start: "250 " + windowHeight * (1 / 2),
				end: "250 " + windowHeight * (1 / 5),
				scrub: 0.75,
				markers: false,
			},
		});

		$i = 1;
		$(".integrations-section--playground .logo").each(function () {
			if ($i == 1 || $i % 2 == 1) {
				integrationsTimelineLeft.to(".logo--" + $i, {
					left: "50%",
					top: "55%",
					transform: "translate(-50%, -50%) scale(.5)",
				});
			} else {
				integrationsTimelineRight.to(".logo--" + $i, {
					right: "50%",
					top: "55%",
					transform: "translate(50%, -50%) scale(.5)",
				});
			}
			$i++;
		});

		integrationsTimelineRight.add(
			TweenLite.to(".passport-logo--outer-ring", 1, {
				transform: "translate(-50%, -50%) scale(1)",
			}),
		);

		integrationsTimelineLogo.add(
			TweenLite.to(".passport-logo--logo", 1, {
				transform: "translate(-50%, -50%) scale(1)",
			}),
		);

		function buildLines() {
			var leftLogos = document.querySelectorAll(".logo.left");
			var rightLogos = document.querySelectorAll(".logo.right");
			var li = 1;
			var ri = 1;
			[].forEach.call(leftLogos, function (item) {
				window["logo" + li] = item;

				if (li >= 2) {
					window["lineLeft" + li] = new LeaderLine(
						LeaderLine.pointAnchor(window["logo" + (li - 1)], {
							x: "50%",
							y: "50%",
						}),
						LeaderLine.pointAnchor(window["logo" + li], { x: "50%", y: "50%" }),
						{
							dash: { animation: true },
							color: "rgba(255, 255, 255, 0.25)",
							size: 3,
							path: "straight",
							startPlug: "behind",
							endPlug: "behind",
						},
					);
				}

				li++;
			});
			[].forEach.call(rightLogos, function (item) {
				window["logo" + ri] = item;

				if (ri >= 2) {
					window["lineRight" + ri] = new LeaderLine(
						LeaderLine.pointAnchor(window["logo" + (ri - 1)], {
							x: "50%",
							y: "50%",
						}),
						LeaderLine.pointAnchor(window["logo" + ri], { x: "50%", y: "50%" }),
						{
							dash: { animation: true },
							color: "rgba(255, 255, 255, 0.25)",
							size: 3,
							path: "straight",
							startPlug: "behind",
							endPlug: "behind",
						},
					);
				}

				ri++;
			});

			setInterval(function () {
				if (li > 2) {
					lineLeft2.position();
				}
				if (li > 3) {
					lineLeft3.position();
				}
				if (li > 4) {
					lineLeft4.position();
				}
				if (li > 5) {
					lineLeft5.position();
				}
				if (li > 6) {
					lineLeft6.position();
				}
				if (li > 7) {
					lineLeft7.position();
				}
				if (li > 8) {
					lineLeft8.position();
				}

				if (ri > 2) {
					lineRight2.position();
				}
				if (ri > 3) {
					lineRight3.position();
				}
				if (ri > 4) {
					lineRight4.position();
				}
				if (ri > 5) {
					lineRight5.position();
				}
				if (ri > 6) {
					lineRight6.position();
				}
				if (ri > 7) {
					lineRight7.position();
				}
				if (ri > 8) {
					lineRight8.position();
				}
			}, 20);
		}

		//drawing lines between two points
		buildLines();
	}
})();

//news grid slider
(function () {
	if ($(".grid-news-slider").length) {
		$(".grid-news-slider .row-of-cards").slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
			],
		});

		$(".grid-news-slider .row-of-cards").on("beforeChange", function () {
			var lazyCardImages = $(
				".grid-news-slider .row-of-cards .card-news.slick-cloned .card-news--image img.lazy",
			);
			lazyCardImages.each(function () {
				if (!$(this).hasClass("loaded")) {
					$(this).attr("src", $(this).data("src"));
					$(this).addClass("loaded");
					$(this).data("was-processed", true);
				}
			});
		});
	}
})();

//integrations slider
(function () {
	if ($(".grid-integrations-slider").length) {
		$(".grid-integrations-slider .row .row-of-cards").slick({
			infinite: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
			],
		});

		$(".grid-integrations-slider .row-of-cards").on(
			"beforeChange",
			function () {
				var lazyCardImages = $(
					".grid-integrations-slider .row-of-cards .card-integrations.slick-cloned img.lazy",
				);
				lazyCardImages.each(function () {
					if (!$(this).hasClass("loaded")) {
						$(this).attr("src", $(this).data("src"));
						$(this).addClass("loaded");
						$(this).data("was-processed", true);
					}
				});
			},
		);
	}
})();

//Employee Attributes block
(function () {
	if ($(".benefits").length) {
		function updateBenefit(item, currentlyActive) {
			currentlyActive.find("button").attr("aria-expanded", "false");
			currentlyActive.find(".desc-list").attr("aria-hidden", "true");
			currentlyActive.toggleClass("active");
			item.find("button").attr("aria-expanded", "true");
			item.find(".desc-list").attr("aria-hidden", "false");
			item.toggleClass("active");
		}
		function checkWidth() {
			if (window.innerWidth < 700) {
				$(".traits li").each(function () {
					$(this).removeClass("active");
					$(this).find("button").attr("aria-expanded", "true");
					$(this).find(".desc-list").attr("aria-hidden", "false");
				});
			} else {
				$(".traits li").each(function () {
					$(this).find("button").attr("aria-expanded", "false");
					$(this).find(".desc-list").attr("aria-hidden", "true");
				});
			}
		}

		checkWidth();
		$(".traits > li").hover(function () {
			if (!$(this).hasClass("active") && window.innerWidth > 700) {
				updateBenefit($(this), $(".traits > li.active"));
			}
		});
		$(".traits > li").click(function () {
			if (!$(this).hasClass("active") && window.innerWidth > 700) {
				updateBenefit($(this), $(".traits > li.active"));
			}
		});
		$(window).resize(checkWidth);
	}
})();

// (function() {
// 	var featuredCardsElement = document.body.querySelector('.blog-grid--featured-cards');
// 	if (featuredCardsElement) {
// 		document.addEventListener('facetwp-loaded', function() {
// 			console.log(FWP.facets);
// 			var hasFiltersApplied = false;
// 			Object.keys(FWP.facets).forEach(function (facetName) {
// 				if (FWP.facets[facetName].length > 0) {
// 					hasFiltersApplied = true;
// 				}
// 			})
// 			if (hasFiltersApplied) {
// 				featuredCardsElement.style.display = 'none';
// 			} else {
// 				featuredCardsElement.style.display = 'grid';
// 			}
// 		});
// 	}
// }());

//Accordions functionality

(function () {
	if ($(".content-accordions").length) {
		var accordions = document.querySelectorAll(".accordion");
		accordions.forEach(function (accordion) {
			// Set ARIA attributes for accessibility
			accordion.setAttribute("role", "button");
			accordion.setAttribute("tabindex", "0");
			accordion.setAttribute("aria-expanded", "false");
			var panel = accordion.nextElementSibling;
			if (panel) {
				panel.setAttribute("aria-hidden", "true");
				panel.style.display = "none";
			}

			function toggleAccordion() {
				var isActive = accordion.classList.toggle("active");
				if (panel) {
					if (isActive) {
						panel.style.display = "block";
						accordion.setAttribute("aria-expanded", "true");
						panel.setAttribute("aria-hidden", "false");
					} else {
						panel.style.display = "none";
						accordion.setAttribute("aria-expanded", "false");
						panel.setAttribute("aria-hidden", "true");
					}
				}
			}

			accordion.addEventListener("click", toggleAccordion);
			accordion.addEventListener("keydown", function (e) {
				if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
					e.preventDefault();
					toggleAccordion();
				}
			});
		});
	}
})();